<style lang="less" scoped>
@import '../../../style/common/variable';
.cardList {position: relative;width: 350px;height: 240px;text-align: left;}
ul {list-style: none;height: 300px;overflow: hidden; margin-top: 0px;text-align: left;text-overflow: ellipsis;white-space: nowrap;width: 100%;}
span::before {content: "●";font-size: 12px;margin-right: 4px;vertical-align: top;}
li {width: 100%;margin-top: 15px;font-family: AlibabaPuHuiTi-Regular;font-size: 14px;font-weight: 600;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
span:hover {color: #13569e;}
span{font-family: AlibabaPuHuiTi-Regular;font-size: 14px;font-weight: normal;font-stretch: normal;line-height: 24px;letter-spacing: 1px;color: #2c3e50;letter-spacing: 1px;cursor: pointer;}
@media screen and (max-width: @max-screen) {
  .list{width: 93vw;}
  ul{height: auto;}
}
</style>

<!--安进  2021.6.30
    该组件使用场景：将标题以列表的形式纵向展示，只展示7条数据，鼠标点击 标题，将 相应的对象 传递给父组件 -->
<template>
  <ul class="list">
    <li v-for="(item, index) in List" :key="index" @click="clickListNews(item)">
      <span v-if="index < 7"> {{ item.title }} </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['List'],
  data()
  {
    return {}
  },
  methods: {
    clickListNews(item)
    {
      this.$emit('clickListNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/DmkyList.vue